import React, { useState } from "react";
import Checkbox from "components/common/Fields/Checkbox";
import ReactStrapTable from "components/reactStrapTable";
import SearchButtons from "components/SearchButtons";
import { Button, ButtonGroup } from "reactstrap";
import downloadIcon from "../../../../assets/icon/download-purple.svg";
import printerIcon from "../../../../assets/icon/printer.svg";
import doubleArrow from "../../../../assets/icon/double-arrow-down.svg";
import refreshIcon from "../../../../assets/icon/reload-icon.svg";
import downloadWhiteIcon from "../../../../assets/icon/download-white.svg";
import addIcon from "../../../../assets/icon/add.svg";
const Documents = () => {
  const [showDetails, setShowDetails] = useState(true);
  const [show, setShow] = useState(false);
  const [refreshBtn, setRefreshBtn] = useState(false);
  const [rSelected, setRSelected] = useState("off");

  const ColumnData = [
    {
      dataField: "all",
      text: (
        <div className="d-flex justify-content-flexstart align-items-center gap-2">
          <Checkbox />
          All
        </div>
      ),
      show: true,
      width: 50,
    },
    {
      dataField: "type",
      text: "Type",
      sort: true,
      show: true,
    },
    {
      dataField: "sender",
      text: "Sender",
      show: true,
      sort: true,
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      show: true,
    },
    {
      dataField: "timerange",
      text: "Time Range",
      sort: true,
      show: true,
    },
  ];

  const rowData = [
    {
      all: <Checkbox />,
      type: "Lorume",
      sender: "Lorume",
      date: "sanmoke",
      timerange: "samoke",
    },
    {
      all: <Checkbox />,
      type: "Lorume",
      sender: "Lorume",
      date: "sanmoke",
      timerange: "samoke",
    },
    {
      all: <Checkbox />,
      type: "Lorume",
      sender: "Lorume",
      date: "sanmoke",
      timerange: "samoke",
    },
  ];

  const handleRefresh = () => {
    setRefreshBtn(true);
    setTimeout(() => {
      setRefreshBtn(false);
    }, 2000);
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <div className="d-flex justify-content-center align-items-center gap-2">
          <div className="d-flex justify-content-end align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </div>
        {refreshBtn && (
          <div className="refresh-bgv">
            <img className="rotate-img" src={refreshIcon} width={40} />
          </div>
        )}
        <div className="d-flex justify-content-center align-items-center">
          <Button
            color="primary"
            className="back-button"
            onClick={handleRefresh}
          >
            <img src={refreshIcon} /> Refresh
          </Button>
        </div>
      </div>
      <div>
        <div className="medical-condition">
          <div className="d-flex justify-content-between align-items-center">
            <div className="heading-text">
              Prescriptions{" "}
              <span onClick={() => setShowDetails(!showDetails)}>
                <img
                  className="cursor-pointer"
                  src={doubleArrow}
                  style={{
                    transform: showDetails ? "rotate(180deg)" : "",
                    transition: "opacity 0.3s ease, transform 0.3s ease",
                  }}
                />
              </span>
            </div>
            <div style={{ opacity: showDetails === false ? "0.4" : "" }}>
              <span className="m-2">
                <img src={printerIcon} />
              </span>
              <img src={downloadIcon} />
            </div>
          </div>
          {showDetails ? (
            <div className="table-card scroll-table position-relative rounded border-0  bg-white">
              <ReactStrapTable
                data={rowData}
                columns={ColumnData}
                hasPagination={false}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="medical-condition">
          <div className="d-flex justify-content-between align-items-center">
            <div className="heading-text">
              Insurance <img src={doubleArrow} />
            </div>
            <div className="gap-2">
              <img src={printerIcon} />
              <img src={downloadIcon} />
            </div>
          </div>
        </div>
        <div className="medical-condition">
          <div className="d-flex justify-content-between align-items-center">
            <div className="heading-text">
              Clinical Notes <img src={doubleArrow} />
            </div>
            <div className="gap-2">
              <img src={printerIcon} />
              <img src={downloadIcon} />
            </div>
          </div>
        </div>
        <div className="medical-condition">
          <div className="d-flex justify-content-between align-items-center">
            <div className="heading-text">
              Prior Authorization <img src={doubleArrow} />
            </div>
            <div className="gap-2">
              <img src={printerIcon} />
              <img src={downloadIcon} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documents;
